export class DamageDetailBase {
    uuid = crypto.randomUUID();
    origin = 'claim';
    is_deleted = false;
    severity = 'low';
    image_info = { image_uuid: '123456789' };
    typology = 'deformation';
    area = 1;
    confidence = 1;
    is_extra = false;
    is_main = true;
    from = 'ai';
    is_deleted_user = undefined;
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            this[key] = value;
        });
    }
}
